import * as React from 'react';
import { Button } from '@rtkwlf/ui';
import Icon from '../../../widgets/Icons';
import { AgentRow } from '../../../types';
import LightTooltip, {
  TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE,
} from '../../../widgets/LightTooltip';
import styled from 'styled-components';

type Props = {
  agent: AgentRow;
  onDelete: (agent: AgentRow) => void;
};

const AgentTrashButton = styled(Button)`
  padding: 0 8px;
  &:disabled {
    border-color: #d3d3d3;
    background-color: #eaeaea;
    color: #9a9a9a;
  }
`;

export const AgentColumnAction: React.FunctionComponent<Props> = (props) => {
  const { agent } = props;

  const onDelete = React.useCallback(() => {
    props.onDelete(agent);
  }, [props, agent]);

  return (
    <div className="column-action-buttons">
      <LightTooltip
        block
        tooltip="Remove offline endpoint"
        delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
        placement={'top'}
        size={'lg'}
      >
        <AgentTrashButton
          onClick={onDelete}
          disabled={agent.status !== 'Offline'}
          data-cy="deactivate"
          type={'danger'}
          ghost
        >
          <Icon.Trash />
        </AgentTrashButton>
      </LightTooltip>
    </div>
  );
};
